
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n136Child = []
  if(this.currentFullActionEditor) {
    n136Child = n136Child.concat(text(this.currentFullActionEditor.renderFull()))
  } else {
    var n137Child = []
    var n138Child = []
    var n139Child = []
    var n140Child = []
    var n141Child = []
    var n142Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-arrow-left'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n142 = h('i', props, n142Child)
    n141Child.push(n142)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n141 = h('span', props, n141Child)
    n140Child.push(n141)
    var n143Child = []
    n143Child = n143Child.concat(text(this.t('.back')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n143 = h('span', props, n143Child)
    n140Child.push(n143)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-light'},{name:'class', val: 'is-small'},{name:'type', val: "button"},{name:'onclick', val: this.dismiss},{name:'title', val: this.t('.back')}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n140 = h('button', props, n140Child)
    n139Child.push(n140)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-item'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n139 = h('div', props, n139Child)
    n138Child.push(n139)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-brand'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n138 = h('div', props, n138Child)
    n137Child.push(n138)
    var n144Child = []
    var n145Child = []
    var n146Child = []
    var n147Child = []
    var n148Child = []
    var n149Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'class', val: 'is-small'},{name:'class', val: 'scene-title-input'},{name:'name', val: "_name"},{name:'value', val: this.scene._name},{name:'placeholder', val: this.t('.scene_name_placeholder')},{name:'oninput', val: this.onSceneNameInput}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n149 = h('input', props, n149Child)
    n148Child.push(n149)
    var n150Child = []
    var n151Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-tag'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n151 = h('i', props, n151Child)
    n150Child.push(n151)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'},{name:'class', val: 'is-left'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n150 = h('span', props, n150Child)
    n148Child.push(n150)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'},{name:'class', val: 'has-icons-left'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n148 = h('div', props, n148Child)
    n147Child.push(n148)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'scene-title-field'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n147 = h('div', props, n147Child)
    n146Child.push(n147)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-item'},{name:'class', val: 'scene-title-item'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n146 = h('div', props, n146Child)
    n145Child.push(n146)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-start'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n145 = h('div', props, n145Child)
    n144Child.push(n145)
    var n152Child = []
    var n153Child = []
    var n154Child = []
    var n155Child = []
    var n156Child = []
    var n157Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-copy'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n157 = h('i', props, n157Child)
    n156Child.push(n157)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n156 = h('span', props, n156Child)
    n155Child.push(n156)
    var n158Child = []
    n158Child = n158Child.concat(text(this.t('.copy')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n158 = h('span', props, n158Child)
    n155Child.push(n158)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-light'},{name:'type', val: "button"},{name:'onclick', val: this.promptCopy},{name:'title', val: this.t('.copy')}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n155 = h('button', props, n155Child)
    n154Child.push(n155)
    var n159Child = []
    var n160Child = []
    var n161Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-trash'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n161 = h('i', props, n161Child)
    n160Child.push(n161)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n160 = h('span', props, n160Child)
    n159Child.push(n160)
    var n162Child = []
    n162Child = n162Child.concat(text(this.t('.delete')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n162 = h('span', props, n162Child)
    n159Child.push(n162)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-danger'},{name:'type', val: "button"},{name:'onclick', val: this.delete},{name:'title', val: this.t('.delete')}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n159 = h('button', props, n159Child)
    n154Child.push(n159)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'buttons'},{name:'class', val: 'are-small'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n154 = h('div', props, n154Child)
    n153Child.push(n154)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-item'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n153 = h('div', props, n153Child)
    n152Child.push(n153)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-end'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n152 = h('div', props, n152Child)
    n144Child.push(n152)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-menu'},{name:'class', val: 'is-active'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n144 = h('div', props, n144Child)
    n137Child.push(n144)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'scene-editor-toolbar'},{name:'class', val: 'navbar'},{name:'class', val: 'is-dark'},{name:'role', val: "navigation"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n137 = h('nav', props, n137Child)
    n136Child.push(n137)
    var n163Child = []
    var v164 = this.allTriggerEditors
    Object.keys(v164).forEach(function (k165) {
      var triggerEditor = v164[k165]
      n163Child = n163Child.concat(text(triggerEditor.render()))
    }.bind(this))
    var n166Child = []
    var n167Child = []
    var n168Child = []
    var n169Child = []
    var n170Child = []
    n170Child = n170Child.concat(text(this.t('.add_trigger')))
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n170 = h('h2', props, n170Child)
    n169Child.push(n170)
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n169 = h('div', props, n169Child)
    n168Child.push(n169)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header-title'},{name:'class', val: 'trigger-editor-title'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n168 = h('div', props, n168Child)
    n167Child.push(n168)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header'},{name:'class', val: 'trigger-editor-card-header'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n167 = h('header', props, n167Child)
    n166Child.push(n167)
    var n171Child = []
    var n172Child = []
    var v173 = this.constructor.CONDITIONS
    Object.keys(v173).forEach(function (type) {
      var conditionClass = v173[type]
      var n174Child = []
      var n175Child = []
      var n176Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: conditionClass.icon}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n176 = h('i', props, n176Child)
      n175Child.push(n176)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n175 = h('span', props, n175Child)
      n174Child.push(n175)
      var n177Child = []
      n177Child = n177Child.concat(text(conditionClass.label))
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'add-trigger-label'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n177 = h('span', props, n177Child)
      n174Child.push(n177)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-light'},{name:'class', val: 'is-fullwidth'},{name:'class', val: 'is-justify-content-flex-start'},{name:'type', val: "button"},{name:'key', val: type},{name:'onclick', val: this.addTrigger.bind(this, conditionClass)}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n174 = h('button', props, n174Child)
      n172Child.push(n174)
    }.bind(this))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'buttons'},{name:'class', val: 'add-trigger-list'},{name:'class', val: 'is-flex-direction-column'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n172 = h('div', props, n172Child)
    n171Child.push(n172)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-content'},{name:'class', val: 'add-trigger-content'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n171 = h('div', props, n171Child)
    n166Child.push(n171)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'trigger-editor-card'},{name:'class', val: 'card'},{name:'class', val: 'add-trigger-card'},{name:'key', val: "add-trigger"}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n166 = h('div', props, n166Child)
    n163Child.push(n166)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'scene-editor-board'},{name:'afterCreate', val: this.bindBoard},{name:'afterUpdate', val: this.bindBoard},{name:'onwheel', val: this.onBoardWheel}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n163 = h('section', props, n163Child)
    n136Child.push(n163)
  }
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'scene-editor'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n136 = h('div', props, n136Child)
  n0Child.push(n136)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  